<script lang="ts" setup>
import { onMounted, onUnmounted, ref } from 'vue'
import { ControlPosition, IControl } from 'mapbox-gl'
import { Icon } from '@iconify/vue2'
import { MapBoxDrawEnum } from './enums/MapBoxDrawMode.enum'
import { useMapBox } from './composables/useMapBox'
import { MapProvider } from './providers/Map.provider'

const props = defineProps<{
	position?: ControlPosition
}>()

let control: IControl | undefined

const drawPolygonButton = ref<HTMLElement>()

const { map, draw } = useMapBox()

onMounted(() => {
	let container: HTMLDivElement

	control = {
		onAdd() {
			container = document.createElement('div')
			container.className = 'mapboxgl-ctrl'

			drawPolygonButton.value?.addEventListener('click', () => {
				MapProvider.clearLineString(draw?.value)
				draw?.value?.changeMode(MapBoxDrawEnum.DRAW_LINE_STRING)
			})

			container.appendChild(drawPolygonButton.value!)

			return container
		},
		onRemove() {
			container?.remove()
		},
	}

	setTimeout(() => map?.value?.addControl(control!, props.position || 'top-right'), 500)
})

onUnmounted(() => {
	if (control) map?.value?.removeControl(control)
})
</script>

<template>
	<button
		style="border: 1px solid #737576"
		class="flex items-center justify-center w-8 h-8 rounded-md bg-white-neutral !hover:bg-white-neutral !border border-gray-medium"
		ref="drawPolygonButton"
	>
		<Icon
			class="text-xl rotate-[45deg]"
			icon="majesticons:ruler-2-line"
		/>
	</button>
</template>

<style>
.mapboxgl-ctrl button:hover {
	background-color: #fefefe !important;
	opacity: 0.95;
}
</style>
